import React, { useState } from 'react';
import axios from 'axios';

const UrlForm = ({ onUrlAdded }) => {
  const [url, setUrl] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    
    // Basic URL validation
    if (!url) {
      setError('Please enter a URL');
      return;
    }
    
    try {
      setIsLoading(true);
      const response = await axios.post('https://surl.yz87.org/urls/', {
        original_url: url
      });
      
      // Clear the form
      setUrl('');
      
      // Notify parent component
      if (onUrlAdded) {
        onUrlAdded(response.data);
      }
    } catch (err) {
      setError('Failed to shorten URL. Please check if it is valid.');
      console.error(err);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <div className="card">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <label htmlFor="url">Enter a long URL to make it shorter</label>
          <input
            type="url"
            id="url"
            value={url}
            onChange={(e) => setUrl(e.target.value)}
            placeholder="https://example.com/long-url-to-shorten"
            required
          />
        </div>
        
        {error && <div style={{ color: 'red', marginBottom: '10px' }}>{error}</div>}
        
        <button type="submit" disabled={isLoading}>
          {isLoading ? 'Shortening...' : 'Shorten URL'}
        </button>
      </form>
    </div>
  );
};

export default UrlForm;
